import { h } from "preact"

export type CellProps = {
   label: string
   row: Object
   formatter: (cell: any, row: Object) => h.JSX.Element | string
   className?: string
}

export default function Cell({ label, row, formatter, className }: CellProps) {
   return <td className={className}>{formatter(label, row)}</td>
}
